// extracted by mini-css-extract-plugin
module.exports = {"desktopCta":"style_desktopCta__UT0lW"};